import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';

class Ticker2 extends Component {


    render() {

        return (

            <div class="ticker-wrap">
            <div class="ticker">
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
              <div class="ticker__item">WELCOME TO THE CRYPTOLAND</div>
            </div>
            </div>)
    }
}

export default Ticker2;